<template>
	<footer class="tcp-footer">
		<div class="tcp-footer__news">
			<h3>Join the Ritual</h3>
			<p>Receive exclusive content, wellness tips, and early access to new products</p>
			<form class="tcp-footer__form" @submit.prevent="subscribe">
				<input v-model="email" type="email" placeholder="your@email.com" required>
				<button type="submit" class="tcp-btn">Subscribe</button>
			</form>
			<p v-if="subscribed" class="tcp-footer__thanks">Thanks. You're on the list.</p>
		</div>

		<div class="tcp-footer__links">
			<div>
				<h4>Shop</h4>
				<ul>
					<li><router-link to="/collections">All Collections</router-link></li>
					<li><router-link to="/shop?sort=newest">New Products</router-link></li>
					<li><router-link to="/shop?sort=best">Best Sellers</router-link></li>
				</ul>
			</div>
			<div>
				<h4>Help</h4>
				<ul>
					<li><router-link to="/faq">FAQ</router-link></li>
					<li><router-link to="/shipping">Shipping</router-link></li>
					<li><router-link to="/returns">Returns</router-link></li>
				</ul>
			</div>
			<div>
				<h4>About Us</h4>
				<ul>
					<li><router-link to="/about">Our Story</router-link></li>
					<li><router-link to="/about">Values</router-link></li>
					<li><router-link to="/contact">Contact</router-link></li>
				</ul>
			</div>
			<div>
				<h4>Follow Us</h4>
				<div class="tcp-footer__social">
					<a v-if="site.instagram" :href="site.instagram" target="_blank" rel="noopener" aria-label="Instagram"><i class="fa fa-instagram"></i></a>
					<a v-if="site.facebook" :href="site.facebook" target="_blank" rel="noopener" aria-label="Facebook"><i class="fa fa-facebook"></i></a>
					<a v-if="site.youtube" :href="site.youtube" target="_blank" rel="noopener" aria-label="YouTube"><i class="fa fa-youtube-play"></i></a>
				</div>
			</div>
		</div>

		<div class="tcp-footer__bottom">
			<p>© {{ year }} The Conscious Pantry. All rights reserved.</p>
			<div class="tcp-footer__lang">
				<span>ES</span>
				<span class="tcp-footer__sep">|</span>
				<span>EN</span>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	data() {
		return {
			email: '',
			subscribed: false,
			site: {
				facebook: '',
				instagram: '',
				youtube: '',
				email: ''
			}
		}
	},
	computed: {
		year() {
			return new Date().getFullYear()
		}
	},
	methods: {
		subscribe() {
			if (!this.email) return
			this.subscribed = true
			this.email = ''
		}
	},
	mounted() {
		axios.get(tools.url('/api/store/site')).then((response) => {
			this.site = Object.assign({}, this.site, response.data || {})
		}).catch(() => {})
	}
}
</script>
